import { createFileRoute } from "@tanstack/react-router";
import { AdminPage } from "@/components/admin/AdminSidebar";
import { LocalesPlataformaPanel } from "@/components/admin/plataforma/LocalesPanel";
import { StaffOnly } from "@/components/admin/plataforma/StaffOnly";

export const Route = createFileRoute("/admin/plataforma/locales")({
  head: () => ({
    meta: [
      { title: "Locales — Admin" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: () => (
    <AdminPage
      title="Locales"
      description="Cola de candidatos de unificación de locales y panorama general."
    >
      <StaffOnly>
        <LocalesPlataformaPanel />
      </StaffOnly>
    </AdminPage>
  ),
});
